/**
 * The video carousel in sections/content-media-slider.liquid.
 *
 * Each section gets one Swiper, built from its own carousel element, and
 * everything below stays inside that carousel. This file used to run
 * `new Swiper('.swiper', ...)`, and Swiper builds an instance for every element
 * a selector matches, so every carousel on the page (the video testimonials,
 * instafeed, the cart drawer's and the header's testimonials) got a second,
 * default Swiper. On a shared element the first instance built takes every
 * swipe and the last one built sets the slide widths, which broke several of
 * them (TASKS #162).
 *
 * The section's <script src> runs this file once per section on the page, so
 * only the first run sets anything up.
 */
(function () {
  'use strict';
  if (window.JiYuContentMediaSlider) return;

  var CAROUSEL = '.radiant-skin-video-carousel';
  var observer = null;

  function play(video) {
    var promise = video.play();
    if (promise && promise.catch) promise.catch(function () {});
  }

  function pauseOthers(carousel, keep) {
    carousel.querySelectorAll('.video-slide video').forEach(function (video) {
      if (video !== keep && !video.paused) video.pause();
    });
  }

  // On load and after every slide change: the active slide's video plays, the
  // rest pause. Browsers refuse the unmuted play on load until the visitor has
  // interacted with the page, so on load it usually stays paused.
  function playActive(swiper) {
    var slide = swiper.slides[swiper.activeIndex];
    var video = slide && slide.querySelector('video');
    pauseOthers(swiper.el, video);
    if (video) play(video);
  }

  // Pauses a carousel's videos once it is mostly out of view. One observer for
  // every carousel on the page.
  function watch(carousel) {
    if (!('IntersectionObserver' in window)) return;
    if (!observer) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) pauseOthers(entry.target, null);
          });
        },
        { threshold: 0.2 }
      );
    }
    observer.observe(carousel);
  }

  function initCarousel(carousel) {
    if (carousel.swiper || typeof Swiper === 'undefined') return;

    // The play button shows the video's real state, whatever started or
    // stopped it (a tap, a slide change, the browser refusing to play).
    carousel.querySelectorAll('.video-slide').forEach(function (slide) {
      var video = slide.querySelector('video');
      var button = slide.querySelector('.carousel-video-play');
      if (!video || !button) return;
      video.addEventListener('play', function () {
        button.classList.add('is-playing');
      });
      video.addEventListener('pause', function () {
        button.classList.remove('is-playing');
      });
    });

    // A tap or click on a slide or its button plays or pauses that slide's
    // video. Swiper cancels the click that ends a drag, so a swipe doesn't.
    carousel.addEventListener('click', function (event) {
      if (event.defaultPrevented) return;
      var slide = event.target.closest('.video-slide');
      var video = slide && slide.querySelector('video');
      if (!video) return;
      if (video.paused) {
        pauseOthers(carousel, video);
        play(video);
      } else {
        video.pause();
      }
    });

    new Swiper(carousel, {
      slidesPerView: 1,
      spaceBetween: 16,
      loop: false,
      grabCursor: true,
      simulateTouch: true,
      allowTouchMove: true,
      touchRatio: 1,
      threshold: 5,
      mousewheel: {
        forceToAxis: true,
        releaseOnEdges: true,
        sensitivity: 1,
        thresholdDelta: 10,
      },
      pagination: {
        el: carousel.querySelector('.swiper-pagination'),
        clickable: true,
      },
      on: {
        init: playActive,
        slideChange: playActive,
      },
    });

    watch(carousel);
  }

  function init(root) {
    (root || document).querySelectorAll(CAROUSEL).forEach(initCarousel);
  }

  function destroy(root) {
    root.querySelectorAll(CAROUSEL).forEach(function (carousel) {
      if (observer) observer.unobserve(carousel);
      if (carousel.swiper) carousel.swiper.destroy(true, true);
    });
  }

  window.JiYuContentMediaSlider = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  // Theme editor: a re-rendered section gets a fresh carousel.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    destroy(event.target);
  });
})();
